"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6174],{

/***/ 73467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CloseIconGrey; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function CloseIconGrey() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.8346 1.34102L10.6596 0.166016L6.0013 4.82435L1.34297 0.166016L0.167969 1.34102L4.8263 5.99935L0.167969 10.6577L1.34297 11.8327L6.0013 7.17435L10.6596 11.8327L11.8346 10.6577L7.1763 5.99935L11.8346 1.34102Z",
            fill: "#B9B9B9"
        })
    });
}


/***/ }),

/***/ 50541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ DropDownArrowSort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DropDownArrowSort = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.59 7.41016L6 2.83016L1.41 7.41016L0 6.00016L6 0.000156403L12 6.00016L10.59 7.41016Z",
            fill: "black"
        })
    });
};


/***/ }),

/***/ 72933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MobileFilterIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MobileFilterIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.58098 1.16602H12.4143C12.5343 1.20811 12.6431 1.27711 12.7323 1.36774C12.8216 1.45836 12.8889 1.56821 12.9291 1.68887C12.9693 1.80952 12.9814 1.93778 12.9644 2.06382C12.9474 2.18986 12.9017 2.31033 12.831 2.41602L8.66431 6.99935V12.8327L5.33098 10.3327V6.99935L1.16431 2.41602C1.09356 2.31033 1.04793 2.18986 1.03092 2.06382C1.01392 1.93778 1.02598 1.80952 1.0662 1.68887C1.10642 1.56821 1.17372 1.45836 1.26295 1.36774C1.35218 1.27711 1.46097 1.20811 1.58098 1.16602Z",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 72468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ MobileSortByArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MobileSortByArrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 4.49935L4.83333 1.16602L8.16667 4.49935M4.83333 1.16602V12.8327",
            stroke: "black",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 42466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getProducts; }
/* harmony export */ });
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);


var getProducts = function(id, type) {
    var pageNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, storeId = arguments.length > 3 ? arguments[3] : void 0;
    var staleStoreId = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch;
    var sID = storeId || staleStoreId;
    if (!sID) return;
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .fetchCatalogItemsByCategoryId */ .Is)({
            store_id: sID,
            category_id: id,
            category_type: type,
            page_no: pageNo
        }, function(status, isNextPage) {
            return status ? resolve({
                status: status,
                isNextPage: isNextPage
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 6174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody7_AdvanceCatalogMiddleBody; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/hooks/useTriggerChangeTopHeightMobile.js
var useTriggerChangeTopHeightMobile = __webpack_require__(2876);
// EXTERNAL MODULE: ./src/hooks/useTriggerInitialFilterOptions.js
var useTriggerInitialFilterOptions = __webpack_require__(42249);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/assets/svgExports/MobileSortByArrow.js
var MobileSortByArrow = __webpack_require__(72468);
// EXTERNAL MODULE: ./src/assets/svgExports/MobileFilterIcon.js
var MobileFilterIcon = __webpack_require__(72933);
// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrowSort.js
var DropDownArrowSort = __webpack_require__(50541);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(71778);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 0 1rem;\n  max-width: 100rem;\n  margin: 0 auto;\n  @media screen and (max-width: ",
        "px) {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  min-height: 100vh;\n  margin: 32px auto 100px auto;\n  width: 100%;\n  max-width: 1500px;\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 22px;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-width: ",
        ";\n  width: ",
        ";\n  max-width: ",
        ";\n  height: fit-content;\n  background: white;\n  border-right: 1px solid #eaeaea;\n  position: sticky;\n  top: 75px;\n  transition: 0.5s width;\n  ",
        "\n  @media screen and (max-width : ",
        "px) {\n    width: 100vw;\n    height: 100vh;\n    z-index: 6;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    max-width: unset;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media screen and (max-width: ",
        "px) {\n    min-height: 150vh;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 11px;\n  padding-right: 8px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  display: flex;\n  flex-direction: row;\n  height: 36px;\n  width: fit-content;\n  border: 1px solid #d1d1d1;\n  align-items: center;\n  cursor: pointer;\n  ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    min-width: 50vw;\n    justify-content: center;\n    height: 48px;\n    border-bottom: none;\n    border-left: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-size: 14px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  font-size: 14px;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media screen and (max-width: ",
        "px) {\n    position: fixed;\n    background: white;\n    z-index: 6;\n    bottom: 0%;\n    left: 0%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 14px;\n  cursor: pointer;\n\n  > svg {\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d1d1d1;\n  position: absolute;\n  transform: translate(0px, 36px);\n  background: white;\n  z-index: 6;\n  padding-top: 25px;\n  min-width: 233px;\n  margin-top: 8px;\n  z-index: 23;\n  @media screen and (max-width: ",
        "px) {\n    bottom: 163%;\n    width: 151vw;\n    padding-top: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  min-width: 158px;\n  margin-bottom: 20px;\n  margin-left: 22px;\n  input[type='radio'] {\n    accent-color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  min-width: 233px;\n  padding: 9px;\n  border: 1px solid #d1d1d1;\n  @media screen and (max-width: ",
        "px) {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    min-width: 50vw;\n    height: 48px;\n    border-left: none;\n    border-bottom: none;\n    border-right: none;\n    ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  > svg {\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 10px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 50vh;\n  z-index: 6;\n  transform: translate(50vw, 0px);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #ededed;\n  margin-bottom: 22px;\n  font-size: 16px;\n  font-weight: 600px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 0px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var AdvMiddleBodyContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AdvMiddleBodyContainer",
    componentId: "sc-8790565b-0"
})(_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf);
var AdvMiddleBodyWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "AdvMiddleBodyWrapper",
    componentId: "sc-8790565b-1"
})(_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var LeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LeftSection",
    componentId: "sc-8790565b-2"
})(_templateObject2(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "262px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "auto";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) ? "0" : "100%";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.visibilty) && "visibility: ".concat(props === null || props === void 0 ? void 0 : props.visibilty, " ; z-index: -1;");
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var MiddleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MiddleSection",
    componentId: "sc-8790565b-3"
})(_templateObject3(), constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterCtaContainer",
    componentId: "sc-8790565b-4"
})(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "visibility: hidden" : "visibility : visible";
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterText",
    componentId: "sc-8790565b-5"
})(_templateObject5());
var FilterIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterIconContainer",
    componentId: "sc-8790565b-6"
})(_templateObject6());
var SortByCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByCtaContainer",
    componentId: "sc-8790565b-7"
})(_templateObject7(), constants/* MAX_MOBILE_WIDTH */.Cf);
var SortFilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortFilterWrapper",
    componentId: "sc-8790565b-8"
})(_templateObject8(), constants/* MAX_MOBILE_WIDTH */.Cf);
var DropDownArrowContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DropDownArrowContainer",
    componentId: "sc-8790565b-9"
})(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "rotate(0deg)" : "rotate(180deg)";
});
var SortByDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByDropDownContainer",
    componentId: "sc-8790565b-10"
})(_templateObject10(), constants/* MAX_MOBILE_WIDTH */.Cf);
var SortByDropDownListInput = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(function(props) {
    return {
        type: (props === null || props === void 0 ? void 0 : props.type) ? props === null || props === void 0 ? void 0 : props.type : "radio",
        value: (props === null || props === void 0 ? void 0 : props.value) ? props === null || props === void 0 ? void 0 : props.value : ""
    };
}).withConfig({
    displayName: "SortByDropDownListInput",
    componentId: "sc-8790565b-11"
})(_templateObject11());
var SortByDropDownListElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByDropDownListElement",
    componentId: "sc-8790565b-12"
})(_templateObject12(), function(props) {
    var ref, ref1, ref2;
    return props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color;
});
var SortByDropDownListLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SortByDropDownListLabel",
    componentId: "sc-8790565b-13"
})(_templateObject13(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) ? 600 : 300;
});
var SortByTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortByTitle",
    componentId: "sc-8790565b-14"
})(_templateObject14(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : props.isApplyActive) && "background : ".concat((ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color, "; color: white");
});
var MobileSortIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortIcon",
    componentId: "sc-8790565b-15"
})(_templateObject15(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.rotate) ? "rotate(180deg)" : "";
});
var MobileSortIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortIconContainer",
    componentId: "sc-8790565b-16"
})(_templateObject16());
var MobileLeftSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileLeftSectionContainer",
    componentId: "sc-8790565b-17"
})(_templateObject17());
var MobileSortHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileSortHeadingContainer",
    componentId: "sc-8790565b-18"
})(_templateObject18());
var MobileSortHeadingText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MobileSortHeadingText",
    componentId: "sc-8790565b-19"
})(_templateObject19());
var MiddleBodyOverflow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MiddleBodyOverflow",
    componentId: "sc-8790565b-20"
})(_templateObject20(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isMobile) ? "auto" : "none";
}, constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/index.js
var utils = __webpack_require__(42466);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCollectionsItems/AllCollectionsItems.styles.ts

function AllCollectionsItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    margin-left: 0px;\n    ",
        ";\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 27px;\n"
    ]);
    AllCollectionsItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #414141;\n  font-size: 17px;\n  font-weight: 500;\n  margin: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    font-size: 12px;\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #797979;\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    AllCollectionsItems_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AllCollectionsItems_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section {\n    margin-top: 24px;\n    display: grid;\n    justify-self: center;\n    justify-items: center;\n    grid-auto-rows: auto;\n\n    @media screen and (min-width: ",
        "px) {\n      grid-template-columns: repeat(3, 1fr);\n      column-gap: 3rem;\n      row-gap: 2rem;\n      justify-self: baseline;\n      justify-items: baseline;\n    }\n    @media screen and (max-width: ",
        "px) {\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 20px;\n      row-gap: 32px;\n      justify-self: center;\n      justify-items: center;\n    }\n  }\n"
    ]);
    AllCollectionsItems_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CollectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionWrapper",
    componentId: "sc-1990bbe8-0"
})(AllCollectionsItems_styles_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "76px" : "";
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "visibility: hidden" : "visibility: visible";
});
var CollectionCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionCategoryWrapper",
    componentId: "sc-1990bbe8-1"
})(AllCollectionsItems_styles_templateObject1());
var CollectionCategoryNameText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CollectionCategoryNameText",
    componentId: "sc-1990bbe8-2"
})(AllCollectionsItems_styles_templateObject2(), function(props) {
    return "0 0 ".concat(props.addBottomSpace ? "27px" : 0, " 0");
}, constants/* MAX_MOBILE_WIDTH */.Cf);
var CollectionNameText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CollectionNameText",
    componentId: "sc-1990bbe8-3"
})(AllCollectionsItems_styles_templateObject3());
var CollectionItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CollectionItemsContainer",
    componentId: "sc-1990bbe8-4"
})(AllCollectionsItems_styles_templateObject4(), constants/* MAX_MOBILE_WIDTH */.Cf, constants/* MAX_MOBILE_WIDTH */.Cf);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCategoriesItems/AllCategoriesItems.styles.ts

function AllCategoriesItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AllCategoriesItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: ",
        "px) {\n    margin-left: 0px;\n    ",
        ";\n  }\n"
    ]);
    AllCategoriesItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 27px;\n  overflow: hidden;\n"
    ]);
    AllCategoriesItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AllCategoriesItems_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AllCategoriesItems_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CategoriesItemsContainer = (0,styled_components_browser_esm/* default */.ZP)(CollectionItemsContainer).withConfig({
    displayName: "CategoriesItemsContainer",
    componentId: "sc-ebef91c8-0"
})(AllCategoriesItems_styles_templateObject());
var CategoriesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoriesWrapper",
    componentId: "sc-ebef91c8-1"
})(AllCategoriesItems_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "visibility: hidden" : "visibility: visible";
});
var CategoryListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryListWrapper",
    componentId: "sc-ebef91c8-2"
})(AllCategoriesItems_styles_templateObject2());
var CategoryName = (0,styled_components_browser_esm/* default */.ZP)(CollectionCategoryNameText).withConfig({
    displayName: "CategoryName",
    componentId: "sc-ebef91c8-3"
})(AllCategoriesItems_styles_templateObject3());

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useOnScreen.js
var useOnScreen = __webpack_require__(97429);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCategoriesItems/AllCategoriesItems.tsx





// import LoaderIcon from '@/components/Common/LoaderIcon';







function AllCategoriesItems(props) {
    var categoryPageNumber = /**
   * @param {number} categoryId
   * @return {number} page number for api.
   */ function categoryPageNumber(categoryId) {
        var ref, ref1, ref2, ref3;
        return ((ref = categoryPaginationStatus.current[categoryId]) === null || ref === void 0 ? void 0 : (ref3 = ref.pages) === null || ref3 === void 0 ? void 0 : ref3[((ref1 = categoryPaginationStatus.current[categoryId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.length) - 1]) + 1;
    };
    var returnNestedCategoryData = /**
   *
   * @param {number} categoryId
   * @return {object} category data that needs to be rendered.
   */ function returnNestedCategoryData(categoryId) {
        var categoryIdValue = undefined;
        categoryIdValue = catalog_items[categoryId];
        return categoryIdValue;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var catalog_items = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalog_items: state.catalogReducer.catalog_items
        };
    }).catalog_items;
    var ref = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            categories: state.catalogReducer.categories
        };
    }), store_id = ref.storeData.store_id, categories = ref.categories;
    /**
   * the following data has been kept in useRef for the purpose of
   * synchronous data manipulation
   */ /**
   * categoryPaginationStatus : it holds data for each category if its nextPage
   * is there and array for page number for which the api has been called
   */ var categoryPaginationStatus = (0,react.useRef)({});
    /**
   * categoryPaginationIterator : its an Iterator to change category nextPage To true
   * when the one category is full rendered and we need to render the next category
   */ // const categoryPaginationIterator = useRef(0);
    /**
   * categoryIdArray : contains categoryId's
   */ var categoryIdArray = (0,react.useRef)([]);
    /**
   * loader : used to control pagination api. if one api is called till its
   * execution is not done loader will not change state and critical section of code
   * is not invoked
   */ var loader = (0,react.useRef)({});
    /**
   * initializing categoryIdArray and categoryPaginationStatus
   */ (0,react.useEffect)(function() {
        var tempCategoryPaginationStatus = {};
        categories && !!(categories === null || categories === void 0 ? void 0 : categories.length) && categories.forEach(function(item, index) {
            var tempStatusObj = {};
            tempStatusObj["isNext"] = index === 0 ? true : false;
            tempStatusObj["pages"] = [
                0
            ];
            tempCategoryPaginationStatus[item.id] = tempStatusObj;
        });
        categoryPaginationStatus.current = tempCategoryPaginationStatus;
        categories && !!(categories === null || categories === void 0 ? void 0 : categories.length) && categories.forEach(function(item) {
            categoryIdArray.current.push(item === null || item === void 0 ? void 0 : item.id);
        });
        return function() {
            dispatch((0,catalog/* resetCatalogsList */.wL)());
        };
    }, [
        categories
    ]);
    function loadMoreDataCategories(categoryId) {
        return _loadMoreDataCategories.apply(this, arguments);
    }
    function _loadMoreDataCategories() {
        _loadMoreDataCategories = /**
   * loads data / is invoked when user Scroll end
   * @param {number} categoryId
   */ (0,_async_to_generator/* default */.Z)(function(categoryId) {
            var ref, ref1, ref2, pageNo, ref3, status, isNextPage, ref4, ref5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageNo = categoryPageNumber(categoryId);
                        if (!(!((ref = loader.current) === null || ref === void 0 ? void 0 : ref[categoryId]) && !((ref1 = categoryPaginationStatus.current[categoryId]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.includes(pageNo)))) return [
                            3,
                            2
                        ];
                        loader.current[categoryId] = true;
                        if (!store_id) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* getProducts */.X)(categoryId, (categoryId === null || categoryId === void 0 ? void 0 : categoryId.hasOwnProperty("is_custom_tag")) ? 1 : 0, pageNo, store_id)
                        ];
                    case 1:
                        ref3 = _state.sent(), status = ref3.status, isNextPage = ref3.isNextPage;
                        if (status) {
                            ;
                            (ref4 = categoryPaginationStatus.current[categoryId]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pages) === null || ref5 === void 0 ? void 0 : ref5.push(pageNo);
                            categoryPaginationStatus.current[categoryId]["isNext"] = isNextPage;
                        }
                        _state.label = 2;
                    case 2:
                        loader.current[categoryId] = false;
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreDataCategories.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesWrapper, {
        showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
        showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
        children: categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection, {
                category: category,
                loadMoreDataCategories: loadMoreDataCategories,
                returnNestedCategoryData: returnNestedCategoryData,
                categoryPaginationStatus: categoryPaginationStatus,
                loader: loader,
                catalog_items: catalog_items
            }, category.id);
        })
    });
}
/* harmony default export */ var AllCategoriesItems_AllCategoriesItems = (AllCategoriesItems);
var CategorySection = function(param) {
    var category = param.category, loadMoreDataCategories = param.loadMoreDataCategories, returnNestedCategoryData = param.returnNestedCategoryData, categoryPaginationStatus = param.categoryPaginationStatus, loader = param.loader, catalog_items = param.catalog_items;
    var ref, ref1;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref2 = (0,react.useRef)();
    var hasLoaded = (0,react.useRef)(false);
    var isVisible = (0,useOnScreen/* default */.Z)(ref2, {
        threshold: 0.1
    });
    (0,react.useEffect)(function() {
        if (isVisible && !hasLoaded.current && !(catalog_items === null || catalog_items === void 0 ? void 0 : catalog_items[category.id])) {
            loadMoreDataCategories(category.id);
            hasLoaded.current = true;
        }
    }, [
        isVisible,
        catalog_items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryListWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryName, {
                    ref: ref2,
                    children: category.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoriesItemsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                            productList: returnNestedCategoryData(category.id),
                            calculateSelfDimensions: true,
                            renderAdvancedCard: true,
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength"
                            },
                            customClass: "tw-mt-[24px]"
                        }),
                        ((ref = categoryPaginationStatus.current[category === null || category === void 0 ? void 0 : category.id]) === null || ref === void 0 ? void 0 : ref.isNext) && !(loader === null || loader === void 0 ? void 0 : (ref1 = loader.current) === null || ref1 === void 0 ? void 0 : ref1[category.id]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-flex tw-justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return loadMoreDataCategories(category.id);
                                },
                                style: {
                                    borderColor: themeColor,
                                    color: themeColor
                                },
                                className: "sm:tw-w-full tw-w-[100px] tw-cursor-pointer tw-mt-24 tw-mb-34 tw-mx-8 tw-border tw-border-solid tw-py-12 tw-text-center tw-text-14 tw-font-medium",
                                children: "View More"
                            })
                        })
                    ]
                })
            ]
        }, category === null || category === void 0 ? void 0 : category.id)
    });
};

// EXTERNAL MODULE: ./src/containers/Collections/FlatListV2.tsx
var FlatListV2 = __webpack_require__(98331);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/AllCollectionsItems/AllCollectionsItems.tsx







function AllCollectionsItems(props) {
    var loadMoreData = /**
   * this function fetches collection category items when data
   * needs to be loaded
   * @param {number} category
   * @param {number} collection
   */ function loadMoreData(category, collection) {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection.id,
                categoryId: category.id
            }));
        }
    };
    var returnNestedCollectionData = /**
   * this function checks collection object for presence of category and its items
   * as it may or may not be there as we call api when we need to show the items
   * @param {number} collectionId
   * @param {number} categoryId
   * @returns {Array}  of items that needs to be rendered in a collection category
   */ function returnNestedCollectionData(collectionId, categoryId) {
        var collectionIdValue = collectionCatalogItems[collectionId];
        var categoryIdValue = undefined;
        if (collectionIdValue) {
            categoryIdValue = collectionIdValue[categoryId];
        }
        return categoryIdValue;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections,
            storeData: state.storeReducer.store
        };
    }), collections = ref.collections, storeData = ref.storeData;
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (collections === null || collections === void 0 ? void 0 : collections.length) ? collections.map(function(collection) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionWrapper, {
                showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
                showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionCategorySection, {
                        category: category,
                        collection: collection,
                        loadMoreData: loadMoreData,
                        returnNestedCollectionData: returnNestedCollectionData
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }, collection === null || collection === void 0 ? void 0 : collection.id);
        }) : null
    });
}
/* harmony default export */ var AllCollectionsItems_AllCollectionsItems = (AllCollectionsItems);
var CollectionCategorySection = function(param) {
    var category = param.category, collection = param.collection, loadMoreData = param.loadMoreData, returnNestedCollectionData = param.returnNestedCollectionData;
    var collectionData = returnNestedCollectionData(collection.id, category.id);
    var handleLoadMore = function() {
        if (collectionData) return;
        loadMoreData(category, collection);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatListV2/* default */.Z, {
        loadMoreData: handleLoadMore,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionCategoryWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionCategoryNameText, {
                    addBottomSpace: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionNameText, {
                            children: "".concat(collection.name, "  /  ")
                        }),
                        category.name
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                        productList: collectionData,
                        oldCardConfigs: {
                            showButton: true,
                            noTagsReadState: "fromLength"
                        },
                        renderAdvancedCard: true,
                        calculateSelfDimensions: true
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js + 4 modules
var FilterDrawer = __webpack_require__(91612);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(55772);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/utils/getFilteredOptionProducts.js
var getFilteredOptionProducts = __webpack_require__(36051);
;// CONCATENATED MODULE: ./src/assets/svgExports/ItemsNotFound.js

function ItemsNotFound() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "250",
        height: "200",
        viewBox: "0 0 250 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "250",
                height: "200",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M120.5 133C139.002 133 154 118.002 154 99.5C154 80.9985 139.002 66 120.5 66C101.998 66 87 80.9985 87 99.5C87 118.002 101.998 133 120.5 133Z",
                fill: "#F2F2F2",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096",
                stroke: "#828282",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M103.797 120.074C105.945 121.82 108.372 123.237 111 124.246",
                stroke: "#828282",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M148 126L154 132",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.029 131.031C151.136 132.924 151.136 135.992 153.029 137.885L164.114 148.97C166.007 150.863 169.076 150.863 170.968 148.97C172.861 147.078 172.861 144.009 170.968 142.116L159.883 131.031C157.99 129.138 154.922 129.138 153.029 131.031Z",
                fill: "#F2F2F2",
                stroke: "#828282",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M158 133L169 144",
                stroke: "white",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M114.001 88.0005C114.001 99.5985 123.403 109.001 135.001 109.001C137.279 109.001 139.472 108.638 141.527 107.967C138.174 116.288 130.023 122.161 120.501 122.161C107.985 122.161 97.8398 112.016 97.8398 99.5005C97.8398 88.1601 106.17 78.7653 117.046 77.1016C115.113 80.2798 114.001 84.0102 114.001 88.0005Z",
                fill: "#F2F2F2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121 81C119.727 81 118.482 81.1253 117.279 81.3642M113.645 82.4761C106.804 85.3508 102 92.1144 102 100",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174.176 99.7773H166M180.5 92H163.324H180.5ZM187.5 92H185.279H187.5Z",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M84.1743 121.777H75.9985M79.4985 113H62.3228H79.4985ZM56.4985 113H52.2773H56.4985Z",
                stroke: "#E0E0E0",
                strokeWidth: "2.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/SortAndFilteredItems/SortAndFilteredItems.styles.ts

function SortAndFilteredItems_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section {\n    margin-top: 24px;\n    display: grid;\n    justify-self: center;\n    justify-items: center;\n    grid-auto-rows: auto;\n\n    @media screen and (min-width: ",
        "px) {\n      grid-template-columns: repeat(3, 1fr);\n      column-gap: 3rem;\n      row-gap: 2rem;\n      margin-left: ",
        ";\n      justify-self: baseline;\n      justify-items: baseline;\n    }\n    @media screen and (max-width: ",
        "px) {\n      grid-template-columns: repeat(2, 1fr);\n      margin-left: 0px;\n      column-gap: 20px;\n      row-gap: 15px;\n      justify-self: center;\n      justify-items: center;\n      ",
        ";\n    }\n  }\n"
    ]);
    SortAndFilteredItems_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SortAndFilteredItems_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    SortAndFilteredItems_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SortAndFilteredItems_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  postion: relative;\n  margin-top: 2rem;\n  @media screen and (min-width: ",
        "px) {\n    width: 60vw;\n  }\n"
    ]);
    SortAndFilteredItems_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var SortAndFilterItemsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SortAndFilterItemsContainer",
    componentId: "sc-671aabb4-0"
})(SortAndFilteredItems_styles_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "76px" : "0px";
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.showSortByDropDown) ? "opacity : 0.2" : "opacity : 1";
});
var ItemsNotFoundSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemsNotFoundSvgContainer",
    componentId: "sc-671aabb4-1"
})(SortAndFilteredItems_styles_templateObject1());
var ItemsNotFoundContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemsNotFoundContainer",
    componentId: "sc-671aabb4-2"
})(SortAndFilteredItems_styles_templateObject2(), constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var MiddleBody7_utils = __webpack_require__(8710);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/SortAndFilteredItems/SortAndFilteredItems.tsx











// import LoaderIcon from '@/components/Common/LoaderIcon';










var middleBodyScrollCorrectionOffset = 80;
var TYPE_TAG = 3;
function SortAndFilteredItems(props) {
    var fetchDataOnCollectionCategoryChange = function fetchDataOnCollectionCategoryChange() {
        var ref = router === null || router === void 0 ? void 0 : router.query, cid = ref.cid, collectionId = ref.collectionId;
        if (cid !== undefined || collectionId !== undefined) {
            initialPlpCall.current = false;
            dispatch((0,catalog/* setSortType */.Td)(constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES));
            dispatch((0,catalog/* resetFilterItems */.V$)());
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                cid: cid,
                collectionId: collectionId,
                sortType: constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES,
                filterAppliedCounter: 0,
                isNextPage: true
            });
            plpInitFilterCall();
        }
    };
    var plpInitFilterCall = function plpInitFilterCall() {
        var ref, ref1;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) {
            var selectedCategory = categories.find(function(categoryItem) {
                var ref;
                return (categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedCategory) {
                var ref2;
                var categoryFilterObject = {};
                var categorySubFilter = [];
                var subFilter = {};
                subFilter["id"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id;
                subFilter["name"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name;
                categorySubFilter.push(subFilter);
                categoryFilterObject["sub_filters"] = categorySubFilter;
                categoryFilterObject["name"] = "Categories";
                categoryFilterObject["type"] = 2;
                categoryFilterObject["is_selected"] = true;
                var filterArr = [
                    categoryFilterObject
                ];
                if (router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.collectionId) {
                    var collectionFilterObject = createCollectionFilterObject();
                    filterArr.push(collectionFilterObject);
                }
                dispatch((0,catalog/* saveFilteredOptions */.Pu)(filterArr));
                setInitialFilter(filterArr);
                plpFilterCall(filterArr, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
            var selectedTag = productTags.find(function(tagItem) {
                var ref;
                return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedTag) {
                var tagFilterObject = {};
                var tagSubFilter = [];
                var subFilter1 = {};
                subFilter1["id"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.id;
                subFilter1["name"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.name;
                tagSubFilter.push(subFilter1);
                tagFilterObject["sub_filters"] = tagSubFilter;
                tagFilterObject["name"] = "Tags";
                tagFilterObject["type"] = 3;
                tagFilterObject["is_selected"] = true;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    tagFilterObject
                ]));
                setInitialFilter([
                    tagFilterObject
                ]);
                plpFilterCall([
                    tagFilterObject
                ], constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
        } else if (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) {
            var collectionFilterObject1 = createCollectionFilterObject();
            dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                collectionFilterObject1
            ]));
            setInitialFilter([
                collectionFilterObject1
            ]);
            plpFilterCall([
                collectionFilterObject1
            ], constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
        }
    };
    var createCollectionFilterObject = function createCollectionFilterObject() {
        var collectionFilterObject = {};
        var collectionSubFilter = [];
        var subFilter = {};
        var selectedCollectionItem = collections.find(function(collectionItem) {
            var ref;
            return collectionItem.id == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.collectionId);
        });
        subFilter["id"] = selectedCollectionItem === null || selectedCollectionItem === void 0 ? void 0 : selectedCollectionItem.id;
        subFilter["name"] = selectedCollectionItem === null || selectedCollectionItem === void 0 ? void 0 : selectedCollectionItem.name;
        collectionSubFilter.push(subFilter);
        collectionFilterObject["sub_filters"] = collectionSubFilter;
        collectionFilterObject["name"] = "Collections";
        collectionFilterObject["type"] = 1;
        collectionFilterObject["colour_code"] = "";
        collectionFilterObject["is_selected"] = true;
        return collectionFilterObject;
    };
    var changeinitialPlpCallToFalse = function changeinitialPlpCallToFalse(status, isNextPage) {
        if (status) {
            initialPlpCall.current = false;
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                isNextPage: isNextPage,
                pageNo: 1
            });
        }
    };
    var plpFilterCall = function plpFilterCall(filterObject, sortType) {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: filterObject
        };
        initialPlpCall.current = true;
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, changeinitialPlpCallToFalse));
    };
    var getSelectedFilters = /**
   * creates Payload of filters for sortAndFilterApi.
   * @returns {array} of selected filters.
   */ function getSelectedFilters() {
        var ref, ref1, ref2, ref3;
        /** add previous filteroption of collection and category and PLP page */ var tempFiltersArray = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) !== undefined ? (0,_to_consumable_array/* default */.Z)(initialFilter) : [];
        if ((initialFilter === null || initialFilter === void 0 ? void 0 : (ref2 = initialFilter[0]) === null || ref2 === void 0 ? void 0 : ref2.type) === TYPE_TAG && (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.cid)) {
            tempFiltersArray = [];
        }
        !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && filteredOptions.forEach(function(filterItem) {
            var ref;
            var tempFilterObject = {};
            var tempSubFilterArray = [];
            !!((ref = filterItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterItem.sub_filters.forEach(function(subFilterItem) {
                var tempSubFilters = {};
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    tempSubFilters["id"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.id;
                    tempSubFilters["name"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.name;
                    tempSubFilters["colour_code"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.colour_code;
                    tempSubFilterArray.push(tempSubFilters);
                }
            });
            if (tempSubFilterArray === null || tempSubFilterArray === void 0 ? void 0 : tempSubFilterArray.length) {
                tempFilterObject["name"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.name;
                tempFilterObject["type"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.type;
                tempFilterObject["sub_filters"] = tempSubFilterArray;
                tempFiltersArray.push(tempFilterObject);
            }
        });
        return tempFiltersArray;
    };
    var removeDuplicateObjects = function removeDuplicateObjects(array) {
        array = Array.isArray(array) ? array : [];
        var uniqueObjects = [];
        var seenIds = new Set();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                var objectId = obj.id;
                if (!seenIds.has(objectId)) {
                    seenIds.add(objectId);
                    uniqueObjects.push(obj);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return uniqueObjects;
    };
    var returnFilterItemsData = function returnFilterItemsData() {
        var items = [];
        if (!mb7SortAndFilterConfig.allowReset) {
            items = mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems;
            dispatch((0,catalog/* saveFilteredItems */.tu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems) || []));
            dispatch((0,catalog/* saveFilteredOptions */.Pu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredOptions) || []));
        } else {
            items = filteredItems;
        }
        return removeDuplicateObjects(items);
    };
    var handleFilterCounterAndSortTypeChange = function handleFilterCounterAndSortTypeChange() {
        var ref, ref1;
        dispatch((0,catalog/* resetFilterItems */.V$)());
        loader.current = false;
        initialFilterSortTypeChangeCall.current = true;
        !isMobile && window.scrollTo({
            top: ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.middleBodyContainerRef) === null || ref === void 0 ? void 0 : ref.current.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) + window.scrollY - middleBodyScrollCorrectionOffset,
            left: 0,
            behavior: "instant"
        });
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: getSelectedFilters()
        };
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, function(status, isNextPage) {
            if (status) {
                initialFilterSortTypeChangeCall.current = false;
                (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                    isNextPage: isNextPage,
                    pageNo: 1,
                    filterAppliedCounterChanged: false,
                    sortTypeChanged: false
                });
            }
        }));
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref4.widgetContextState.globalStyle;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref5[0];
    var ref6 = (0,react.useState)([]), initialFilter = ref6[0], setInitialFilter = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredItems: state.catalogReducer.filteredItems,
            filteredOptions: state.catalogReducer.filteredOptions,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filterOptionLoader: state.commonReducer.filterOptionLoader
        };
    }), filteredItems = ref7.filteredItems, filteredOptions = ref7.filteredOptions, filterAppliedCounter = ref7.filterAppliedCounter, sortType = ref7.sortType, filterOptionLoader = ref7.filterOptionLoader;
    var ref8 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2;
        return {
            categories: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.categories,
            collections: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.collections,
            storeData: state.storeReducer.store,
            productTags: (ref2 = state.catalogReducer) === null || ref2 === void 0 ? void 0 : ref2.productTags
        };
    }), categories = ref8.categories, collections = ref8.collections, storeData = ref8.storeData, productTags = ref8.productTags;
    var loader = (0,react.useRef)(false);
    var initialPlpCall = (0,react.useRef)(false);
    var initialFilterSortTypeChangeCall = (0,react.useRef)(false);
    var mb7SortAndFilterConfig = (0,MiddleBody7_utils/* getStoredMB7SortAndFilterConfig */.Tr)();
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    /**
   * If item is clicked and user navigates back to PLP, restore scroll to that particular item
   */ (0,react.useEffect)(function() {
        (0,MiddleBody7_utils/* scrollIfItemPreviouslyClicked */.Wu)();
    }, []);
    /**
   * If there is no change in filter from the one previously stored, then return. This prevents unnecessary API calls when component first mounts and each useeffect is called once.
   */ (0,react.useEffect)(function() {
        if ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) && (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filterAppliedCounterChanged)) {
            handleFilterCounterAndSortTypeChange();
        }
    }, [
        filterAppliedCounter
    ]);
    (0,react.useEffect)(function() {
        if ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) && (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.sortTypeChanged)) {
            handleFilterCounterAndSortTypeChange();
        }
    }, [
        sortType
    ]);
    (0,react.useEffect)(function() {
        if (mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.allowReset) {
            fetchDataOnCollectionCategoryChange();
        } else {
            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                allowReset: true
            });
            dispatch((0,catalog/* saveFilteredItems */.tu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredItems) || []));
            dispatch((0,catalog/* saveFilteredOptions */.Pu)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.filteredOptions) || []));
            dispatch((0,catalog/* setSortType */.Td)((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.sortType) || constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES));
        }
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid,
        router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId
    ]);
    function loadMoreItems() {
        return _loadMoreItems.apply(this, arguments);
    }
    function _loadMoreItems() {
        _loadMoreItems = (0,_async_to_generator/* default */.Z)(function() {
            var nextPageNumber, ref, status, is_next_page;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage)) {
                            return [
                                2
                            ];
                        }
                        nextPageNumber = ((mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.pageNo) || 0) + 1;
                        if (!(!loader.current && !initialPlpCall.current && !initialFilterSortTypeChangeCall.current)) return [
                            3,
                            2
                        ];
                        loader.current = true;
                        return [
                            4,
                            (0,getFilteredOptionProducts/* getFilteredOptionsProducts */.H)(getSelectedFilters(), nextPageNumber, {
                                isMiddleBody7: true
                            })
                        ];
                    case 1:
                        ref = _state.sent(), status = ref.status, is_next_page = ref.is_next_page;
                        if (status) {
                            (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
                                isNextPage: is_next_page,
                                pageNo: nextPageNumber
                            });
                        }
                        loader.current = false;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreItems.apply(this, arguments);
    }
    var handleCardClick = function(data) {
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            filteredItems: filteredItems,
            filteredOptions: filteredOptions,
            filterAppliedCounter: filterAppliedCounter,
            allowReset: !(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length),
            sortType: sortType
        }, true);
        onItemClick(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortAndFilterItemsContainer, {
            showFilterDrawer: props === null || props === void 0 ? void 0 : props.showFilterDrawer,
            showSortByDropDown: props === null || props === void 0 ? void 0 : props.showSortByDropDown,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                    isLoaderVisible: false,
                    isNext: true,
                    onScrollEnd: function() {
                        return loadMoreItems();
                    },
                    // add LoaderComponent for loading sections
                    renderInsideFragment: true,
                    renderList: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                            customClass: "tw-mt-[24px]",
                            productList: returnFilterItemsData(),
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength",
                                onItemClick: handleCardClick
                            },
                            renderAdvancedCard: true,
                            calculateSelfDimensions: true
                        });
                    }
                }),
                loader.current && !!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center mt4 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                        type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.loaderId) || "ellipsis",
                        color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.appLoader) === null || ref3 === void 0 ? void 0 : ref3.color
                    })
                }),
                !(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) && !!(mb7SortAndFilterConfig === null || mb7SortAndFilterConfig === void 0 ? void 0 : mb7SortAndFilterConfig.isNextPage) && !filterOptionLoader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemsNotFoundContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsNotFoundSvgContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsNotFound, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex w-100 justify-center",
                            children: "No Results Found"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var SortAndFilteredItems_SortAndFilteredItems = (SortAndFilteredItems);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody.js
/* eslint-disable new-cap */ // eslint-disable-next-line no-undef

var ref = __webpack_require__(46431), motion = ref.motion, AnimatePresence = ref.AnimatePresence;




















function AdvanceCatalogMiddleBody() {
    var handleSortByClick = function handleSortByClick() {
        // simulates apply condition in Mobile when FilterDrawer is open
        if (isMobile && showFilterDrawer) {
            setShowFilterDrawer(!showFilterDrawer);
            setTimeout(function() {
                setShowFilterDrawerDelay(!showFilterDrawerDelay);
            }, 525);
            setMobilePrevFilterOption(filteredOptions);
            return;
        } else if (isMobile && showSortByDropDown) {
            setShowSortByDropDown(!showSortByDropDown);
            return;
        } else setShowSortByDropDown(!showSortByDropDown);
    };
    var getCorrectedFilterAppliedCounter = function getCorrectedFilterAppliedCounter() {
        var newFilteredAppliedCounter = 0;
        mobilePrevFilterOption && mobilePrevFilterOption.forEach(function(item) {
            var ref;
            !!(item === null || item === void 0 ? void 0 : (ref = item.sub_filter) === null || ref === void 0 ? void 0 : ref.length) && (item === null || item === void 0 ? void 0 : item.sub_filter.forEach(function(subFilterItem) {
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    newFilteredAppliedCounter++;
                }
            }));
        });
        dispatch((0,catalog/* filtersCounter */.Ds)(newFilteredAppliedCounter, true));
    };
    var getFilterOptionSelectedArray = function getFilterOptionSelectedArray(localfilterOptions) {
        var selectedSubFilters = [];
        !!(localfilterOptions === null || localfilterOptions === void 0 ? void 0 : localfilterOptions.length) && localfilterOptions.forEach(function(filterOptionItem) {
            var ref;
            !!((ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterOptionItem.sub_filters.forEach(function(item) {
                (item === null || item === void 0 ? void 0 : item.is_selected) && selectedSubFilters.push(item === null || item === void 0 ? void 0 : item.name);
            });
        });
        return selectedSubFilters;
    };
    var isFilterOptionAsPrevious = /**
   * checks whether two array are equal or not
   * @param {*} prevFilterOptions FilterOption State in Mobile before Current Session
   * @param {*} currentFilterOptions FilterOption State in Current Session
   * @returns {boolean} if both arrays are same return true else false
   */ function isFilterOptionAsPrevious(prevFilterOptions, currentFilterOptions) {
        var prevSelectedSubFilters = getFilterOptionSelectedArray(prevFilterOptions);
        var currentSelectedSubFilters = getFilterOptionSelectedArray(currentFilterOptions);
        if (prevSelectedSubFilters.length === currentSelectedSubFilters.length) {
            return prevSelectedSubFilters.every(function(element, index) {
                if (element === currentSelectedSubFilters[index]) {
                    return true;
                }
                return false;
            });
        }
        return false;
    };
    var handleShowFilterDrawerAndClose = /**
   * when filter drawer close in mobile the checked states need to be reset
   * to previous state so does filterApplied counter
   * @returns {*}
   */ function handleShowFilterDrawerAndClose() {
        if (isMobile && showSortByDropDown) {
            showSortByDropDown && handleSortByClick();
            showFilterDrawer && setShowFilterDrawer(!showFilterDrawer);
            return;
        } else if (isMobile && showFilterDrawerDelay) {
            if (!isFilterOptionAsPrevious(mobilePrevFilterOption, filteredOptions)) getCorrectedFilterAppliedCounter();
            !!(mobilePrevFilterOption === null || mobilePrevFilterOption === void 0 ? void 0 : mobilePrevFilterOption.length) && dispatch((0,catalog/* saveFilteredOptions */.Pu)(mobilePrevFilterOption));
        }
        setShowFilterDrawer(!showFilterDrawer);
        setTimeout(function() {
            setShowFilterDrawerDelay(!showFilterDrawerDelay);
        }, 525);
    };
    var handleSortItemClick = function handleSortItemClick(e, sortItem) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        dispatch((0,catalog/* setSortType */.Td)(sortItem.type));
        (0,MiddleBody7_utils/* setMB7SortAndFilterConfig */.lr)({
            sortTypeChanged: true
        });
        !isMobile && handleSortByClick();
    };
    var getNameFromSortType = function getNameFromSortType() {
        var ref;
        return (ref = constants/* SortList */.j && !!(constants/* SortList */.j === null || constants/* SortList */.j === void 0 ? void 0 : constants/* SortList.length */.j.length) && constants/* SortList.find */.j.find(function(item) {
            return item.type === sortType;
        })) === null || ref === void 0 ? void 0 : ref.name;
    };
    var renderFilterDrawer = function renderFilterDrawer() {
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLeftSectionContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                    handleShowFilterDrawer: handleShowFilterDrawerAndClose
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                handleShowFilterDrawer: handleShowFilterDrawerAndClose
            })
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: -100,
                    zIndex: 3
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence, {
            children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                transition: {
                    duration: 0.5
                },
                animate: {
                    opacity: 1,
                    x: 0,
                    zIndex: 3
                },
                exit: {
                    opacity: 0,
                    x: 0,
                    zIndex: -1
                },
                children: renderFilterDrawer()
            }, "filterDrawer")
        });
    };
    var renderLeftSection = function renderLeftSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop(),
                !(showFilterDrawer ? showFilterDrawer : showFilterDrawerDelay) && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                    visibilty: "hidden"
                })
            ]
        });
    };
    var renderFilterCta = function renderFilterCta() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCtaContainer, {
            id: "FilterCtaContainer",
            onClick: handleShowFilterDrawerAndClose,
            showFilterDrawer: isMobile ? false : showFilterDrawer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIconContainer, {
                    children: isMobile ? isSortFilterOptionsActive ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterIcon/* MobileFilterIcon */.H, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterText, {
                    children: isMobile ? isSortFilterOptionsActive ? "Close" : "Filters" : "Filters"
                })
            ]
        });
    };
    var renderSortArrowIcon = function renderSortArrowIcon() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSortIconContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortIcon, {
                    rotate: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortByArrow/* MobileSortByArrow */.P, {})
                })
            ]
        });
    };
    var renderMobileSortByHeading = function renderMobileSortByHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSortHeadingText, {
                children: "Sort By"
            })
        });
    };
    var sortByDesktopText = function sortByDesktopText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "flex flex-row",
            children: [
                "Sort By:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ml6px fw6 flex justify-center align-center",
                    children: getNameFromSortType()
                })
            ]
        });
    };
    var renderSortByCta = function renderSortByCta() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByCtaContainer, {
            onClick: handleSortByClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByTitle, {
                    storeInfo: store,
                    isApplyActive: isMobile && isSortFilterOptionsActive,
                    children: [
                        isMobile && (isSortFilterOptionsActive ? null : renderSortArrowIcon()),
                        isMobile ? isSortFilterOptionsActive ? "Apply" : "Sort By" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: sortByDesktopText()
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                            showSortByDropDown: showSortByDropDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSort/* DropDownArrowSort */.b, {})
                        })
                    ]
                }),
                showSortByDropDown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownContainer, {
                    children: [
                        isMobile && renderMobileSortByHeading(),
                        constants/* SortList.map */.j.map(function(sortItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortByDropDownListElement, {
                                storeInfo: store,
                                onClick: function(e) {
                                    handleSortItemClick(e, sortItem);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListInput, {
                                        checked: sortItem.type === sortType ? true : false,
                                        type: "radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropDownListLabel, {
                                        isSelected: sortItem.type === sortType ? true : false,
                                        children: sortItem.name
                                    })
                                ]
                            }, "Sort-DropDown-list-".concat(sortItem.name));
                        })
                    ]
                })
            ]
        });
    };
    var SortAndFilterCtaTab = function SortAndFilterCtaTab() {
        if (isMobile && !showSortAndFilterMobileCta) return null;
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortFilterWrapper, {
            children: [
                renderFilterCta(),
                renderSortByCta()
            ]
        });
    };
    var renderCategoryItemList = function renderCategoryItemList() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCategoriesItems_AllCategoriesItems, {
                    showSortByDropDown: showSortByDropDown,
                    showFilterDrawer: showFilterDrawer
                })
            ]
        });
    };
    var renderSortAndFilteredItems = function renderSortAndFilteredItems() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyOverflow, {
            isMobile: isMobile,
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilteredItems_SortAndFilteredItems, {
                    middleBodyContainerRef: middleBodyContainerRef,
                    showSortByDropDown: showSortByDropDown,
                    showFilterDrawer: showFilterDrawer
                })
            ]
        });
    };
    var renderMiddleBodyAnimated = function renderMiddleBodyAnimated() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isMobile ? renderMiddleSection() : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    x: 0
                },
                transition: {
                    duration: 0.5
                },
                animate: showFilterDrawer ? {
                    x: 0
                } : {},
                className: "tw-w-full",
                children: renderMiddleSection()
            }, "middleBodyAnimated")
        });
    };
    var renderMiddleSection = function renderMiddleSection() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleSection, {
            ref: middleBodyRef,
            children: filterAppliedCounter || sortType || CollectionOrCategoryId ? renderSortAndFilteredItems() : isCollection ? collectionCategoryItemsList() : renderCategoryItemList()
        });
    };
    var ref, ref1;
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), showSortByDropDown = ref2[0], setShowSortByDropDown = ref2[1];
    var ref3 = (0,react.useState)(false), showFilterDrawer = ref3[0], setShowFilterDrawer = ref3[1];
    var ref4 = (0,react.useState)(false), showFilterDrawerDelay = ref4[0], setShowFilterDrawerDelay = ref4[1];
    var ref5 = (0,react.useState)([]), mobilePrevFilterOption = ref5[0], setMobilePrevFilterOption = ref5[1];
    var ref6 = (0,react.useState)(false), isSortFilterOptionsActive = ref6[0], setIsSortFilterOptionsActive = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filteredOptions: state.catalogReducer.filteredOptions,
            headerRef: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.headerRef
        };
    }), filterAppliedCounter = ref7.filterAppliedCounter, sortType = ref7.sortType, filteredOptions = ref7.filteredOptions, headerRef = ref7.headerRef;
    var ref8 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            collections: state.catalogReducer.collections,
            store: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store
        };
    }), store = ref8.store, collections = ref8.collections;
    var middleBodyRef = (0,react.useRef)();
    var middleBodyContainerRef = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var isCollection = (collections === null || collections === void 0 ? void 0 : collections.length) ? true : false;
    var CollectionOrCategoryId = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId);
    /**
   * checks when to show sortAndFilter Cta in mobile base on height
   * from bottom and top of middleBody.
   */ var showSortAndFilterMobileCta = (0,useTriggerChangeTopHeightMobile/* default */.Z)(middleBodyRef, isSortFilterOptionsActive, 150, 360);
    /** initial api call to get filterOptionList */ (0,useTriggerInitialFilterOptions/* default */.Z)(!CollectionOrCategoryId);
    (0,react.useEffect)(function() {
        setIsSortFilterOptionsActive(showSortByDropDown || showFilterDrawer);
    }, [
        showSortByDropDown,
        showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,catalog/* filtersCounter */.Ds)(0, true));
        };
    }, []);
    /**
   * on mobile if filterDrawer is Active stop
   * Body from overflowing
   */ (0,react.useEffect)(function() {
        if (isSortFilterOptionsActive && isMobile) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            setTimeout(function() {
                middleBodyRef.current.scrollIntoView();
            }, 600);
        } else document.getElementsByTagName("body")[0].style.overflowY = "auto";
        return function() {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        };
    }, [
        isSortFilterOptionsActive
    ]);
    (0,react.useEffect)(function() {
        if (isMobile && headerRef.current) {
            showFilterDrawer ? headerRef.current.style.display = "none" : headerRef.current.style.display = "";
        }
    }, [
        showFilterDrawer
    ]);
    var collectionCategoryItemsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sortAndFilterCollection collection-category-items ".concat(isMobile ? "" : "mr76px"),
            children: [
                SortAndFilterCtaTab(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCollectionsItems_AllCollectionsItems, {
                    showFilterDrawer: showFilterDrawer,
                    showSortByDropDown: showSortByDropDown
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvMiddleBodyWrapper, {
        ref: middleBodyContainerRef,
        children: [
            renderLeftSection(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvMiddleBodyContainer, {
                children: renderMiddleBodyAnimated()
            })
        ]
    });
}
/* harmony default export */ var MiddleBody7_AdvanceCatalogMiddleBody = (AdvanceCatalogMiddleBody);


/***/ }),

/***/ 91612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FilterDrawer_FilterDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconGrey.js
var CloseIconGrey = __webpack_require__(73467);
;// CONCATENATED MODULE: ./src/assets/svgExports/ColoredRectangle.js

function ColoredRectangle(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            y: "0.00390625",
            width: "18",
            height: "18",
            fill: (props === null || props === void 0 ? void 0 : props.color) ? props === null || props === void 0 ? void 0 : props.color : "none"
        })
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var utils = __webpack_require__(8710);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  margin-left: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #eaeaea;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  overflow: hidden;\n  white-space: nowrap;\n  align-items: center;\n  text-overflow: ellipsis;\n  > input {\n    transform: scale(1.25);\n  }\n  > label {\n    max-width: 200px;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-top: 14px;\n  cursor: pointer;\n  font-weight: 300;\n  font-size: 14px;\n  margin-left: 18px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  margin-top: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-weight: 300;\n  font-size: 14px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background: #f7f7f7;\n  min-height: 90vh;\n  border-right: 1px solid #ededed;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 32vw;\n  padding: 16px;\n  ",
        ";\n  border-bottom: 1px solid #ededed;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction row;\n  margin-top: 20px;\n  align-items: center;\n   > input {\n    transform: scale(1.25);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var FilterComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentContainer",
    componentId: "sc-18ce1c48-0"
})(_templateObject());
var FilterComponentHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentHeading",
    componentId: "sc-18ce1c48-1"
})(_templateObject1());
var FilterComponentListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListContainer",
    componentId: "sc-18ce1c48-2"
})(_templateObject2());
var FilterComponentListElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentListElement",
    componentId: "sc-18ce1c48-3"
})(_templateObject3());
var FilterComponentViewMore = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentViewMore",
    componentId: "sc-18ce1c48-4"
})(_templateObject4(), (0,getThemeColor/* getThemeColor */.p)());
var FilterColoredComponent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterColoredComponent",
    componentId: "sc-18ce1c48-5"
})(_templateObject5());
var FilterComponentText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentText",
    componentId: "sc-18ce1c48-6"
})(_templateObject6());
var FilterComponentMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileContainer",
    componentId: "sc-18ce1c48-7"
})(_templateObject7(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events: none" : "";
});
var FilterComponentMobileHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeadingContainer",
    componentId: "sc-18ce1c48-8"
})(_templateObject8());
var FilterComponentMobileHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterComponentMobileHeading",
    componentId: "sc-18ce1c48-9"
})(_templateObject9(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) && "background : #FFFFFF";
});
var FilterComponentMobileHeadingText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileHeadingText",
    componentId: "sc-18ce1c48-10"
})(_templateObject10());
var FilterComponentMobileRightContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileRightContainer",
    componentId: "sc-18ce1c48-11"
})(_templateObject11());
var FilterComponentMobileInput = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "FilterComponentMobileInput",
    componentId: "sc-18ce1c48-12"
})(_templateObject12());

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterComponent/FilterComponent.js










var MAX_ITEMS_SHOW_LIMIT = 5;
function FilterComponent(props) {
    var setSelectedFilter = function setSelectedFilter() {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name);
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var getFilterType = function getFilterType() {
        var ref, ref1;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) return 2;
        else if (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) return 1;
        return;
    };
    var handleViewMoreClick = function handleViewMoreClick(ListElement) {
        var length = (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) ? ListElement === null || ListElement === void 0 ? void 0 : ListElement.length : ListElement;
        setShowItemsLimit(length);
    };
    var handleSelectedMobileFilter = function handleSelectedMobileFilter(itemName) {
        var newSelectedFilterForMobile = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.find(function(item) {
            return item.name === itemName;
        });
        newSelectedFilterForMobile && setSelectedMobileFilter(newSelectedFilterForMobile);
    };
    var handleCheckboxClick = /**
   * set is_selected value for sub_filter and changes filterApplied counter and saves
   * new filterOptions in reducer.
   * @param {*} e event on checkbox
   * @param {*} filterOptionName the name of filter option that is currently shown
   * @param {*} subFilterName the name of subfilter that is checked/unchecked by user.
   */ function handleCheckboxClick(e, filterOptionName, subFilterName) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        var tempFilterOptions = filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.slice(filteredOptions, filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length);
        for(var i = 0; i < (tempFilterOptions === null || tempFilterOptions === void 0 ? void 0 : tempFilterOptions.length); i++){
            var ref;
            if (filterOptionName === ((ref = tempFilterOptions[i]) === null || ref === void 0 ? void 0 : ref.name)) {
                var ref1, ref2;
                for(var j = 0; j < ((ref1 = tempFilterOptions[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length); j++){
                    var ref3;
                    if (subFilterName === ((ref3 = tempFilterOptions[i].sub_filters[j]) === null || ref3 === void 0 ? void 0 : ref3.name)) {
                        e.target.checked ? tempFilterOptions[i].sub_filters[j]["is_selected"] = true : tempFilterOptions[i].sub_filters[j]["is_selected"] = false;
                        break;
                    }
                }
            }
        }
        setToggleClick(!toggleClick);
        var filterCounter = e.target.checked ? constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC : constants/* FILTER_COUNTER_OPTIONS.DEC */.zO.DEC;
        dispatch((0,catalog/* filtersCounter */.Ds)(filterCounter));
        dispatch((0,catalog/* saveFilteredOptions */.Pu)(tempFilterOptions));
        (0,utils/* setMB7SortAndFilterConfig */.lr)({
            filterAppliedCounterChanged: true
        });
    };
    var renderViewMore = function renderViewMore(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: [
                "+ ",
                (ListElement === null || ListElement === void 0 ? void 0 : ListElement.length) - MAX_ITEMS_SHOW_LIMIT,
                " more"
            ]
        });
    };
    var renderViewLess = function renderViewLess(ListElement) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentViewMore, {
            onClick: function() {
                handleViewMoreClick(ListElement);
            },
            children: "View Less"
        });
    };
    var getTotalItemsCheckCount = function getTotalItemsCheckCount(filterOptionItem) {
        var ref;
        var totalCheckedCount = 0;
        !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters) && !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.sub_filters.forEach(function(item) {
            item.is_selected && totalCheckedCount++;
        }));
        return totalCheckedCount;
    };
    var removeCollectionOrCategoryFromPLP = function removeCollectionOrCategoryFromPLP(filterType) {
        var ref, ref1;
        if ((props === null || props === void 0 ? void 0 : props.hideCollectionFilter) && filterType === 1) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideCategoryFilter) && filterType === 2) {
            return false;
        }
        if ((props === null || props === void 0 ? void 0 : props.hideTags) && filterType === 3) {
            return false;
        }
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) && filterType === 2) {
            return false;
        } else if ((router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) && filterType === 1) {
            return false;
        }
        return true;
    };
    var renderMobileFilterComponent = function renderMobileFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileContainer, {
            loader: filterOptionLoader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeadingContainer, {
                    children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOptionItem) {
                        var ref;
                        return !!(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : (ref = filterOptionItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && removeCollectionOrCategoryFromPLP(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileHeading, {
                            isSelected: (filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name) === (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.name),
                            onClick: function() {
                                handleSelectedMobileFilter(filterOptionItem === null || filterOptionItem === void 0 ? void 0 : filterOptionItem.name);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileHeadingText, {
                                children: [
                                    filterOptionItem.name,
                                    !!getTotalItemsCheckCount(filterOptionItem) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw3 ml8px",
                                        children: "(".concat(getTotalItemsCheckCount(filterOptionItem), ")")
                                    })
                                ]
                            })
                        }, "".concat(filterOptionItem.name).concat(filterOptionItem.type));
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponentMobileRightContainer, {
                    children: (selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.sub_filters) && selectedMobileFilter.sub_filters.map(function(item) {
                        return removeCollectionOrCategoryFromPLP(selectedMobileFilter === null || selectedMobileFilter === void 0 ? void 0 : selectedMobileFilter.type) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentMobileInput, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    className: "ml24px pointer",
                                    checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                    id: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    onClick: function(e) {
                                        return handleCheckboxClick(e, selectedMobileFilter.name, item.name);
                                    }
                                }),
                                selectedMobileFilter.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px mt2px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                        color: item === null || item === void 0 ? void 0 : item.colour_code
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "".concat(selectedMobileFilter.name, "-").concat(item.name),
                                    className: "pointer ml10px fw3 f14px",
                                    children: item.name
                                })
                            ]
                        }, "subFilter-".concat(item === null || item === void 0 ? void 0 : item.name, "-").concat(item === null || item === void 0 ? void 0 : item.id));
                    })
                })
            ]
        });
    };
    var renderDesktopFilterComponent = function renderDesktopFilterComponent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function(filterOption) {
                var ref, ref1, ref2, ref3;
                return removeCollectionOrCategoryFromPLP(filterOption === null || filterOption === void 0 ? void 0 : filterOption.type) && !!(filterOption === null || filterOption === void 0 ? void 0 : (ref = filterOption.sub_filters) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentHeading, {
                            children: [
                                filterOption.name,
                                !!getTotalItemsCheckCount(filterOption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "fw3 ml8px",
                                    children: "(".concat(getTotalItemsCheckCount(filterOption), ")")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListContainer, {
                            children: [
                                filterOption === null || filterOption === void 0 ? void 0 : (ref1 = filterOption.sub_filters) === null || ref1 === void 0 ? void 0 : ref1.slice(0, showItemsLimit).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterComponentListElement, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "ml4px pointer",
                                                checked: item === null || item === void 0 ? void 0 : item.is_selected,
                                                id: "".concat(filterOption.name, "-").concat(item.name),
                                                onClick: function(e) {
                                                    return handleCheckboxClick(e, filterOption.name, item.name);
                                                }
                                            }),
                                            filterOption.name === constants/* COLOR_FILTER_OPTION */.uh && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px mt2px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangle, {
                                                    color: item === null || item === void 0 ? void 0 : item.colour_code
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "".concat(filterOption.name, "-").concat(item.name),
                                                className: "pointer ml10px fw3 f14px",
                                                children: item.name
                                            })
                                        ]
                                    }, "".concat(filterOption.name, "-").concat(item.name, "-filterOption-subFilters"));
                                }),
                                (filterOption === null || filterOption === void 0 ? void 0 : (ref2 = filterOption.sub_filters) === null || ref2 === void 0 ? void 0 : ref2.length) > showItemsLimit && renderViewMore(filterOption === null || filterOption === void 0 ? void 0 : filterOption.sub_filters),
                                !!((filterOption === null || filterOption === void 0 ? void 0 : (ref3 = filterOption.sub_filters) === null || ref3 === void 0 ? void 0 : ref3.length) === showItemsLimit && showItemsLimit > MAX_ITEMS_SHOW_LIMIT) && renderViewLess(MAX_ITEMS_SHOW_LIMIT)
                            ]
                        })
                    ]
                }, "".concat(filterOption.name, "-filterOption")) : null;
            }))
        });
    };
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(MAX_ITEMS_SHOW_LIMIT), showItemsLimit = ref[0], setShowItemsLimit = ref[1];
    var ref1 = (0,react.useState)({}), selectedMobileFilter = ref1[0], setSelectedMobileFilter = ref1[1];
    var ref2 = (0,react.useState)(false), toggleClick = ref2[0], setToggleClick = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredOptions: state.catalogReducer.filteredOptions,
            filterOptionLoader: state.commonReducer.filterOptionLoader,
            hideFiltersCategoryAndCollection: state.commonReducer.hideFiltersCategoryAndCollection
        };
    }), filteredOptions = ref3.filteredOptions, filterOptionLoader = ref3.filterOptionLoader, hideFiltersCategoryAndCollection = ref3.hideFiltersCategoryAndCollection;
    (0,react.useEffect)(function() {
        !!filteredOptions && !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && isMobile && hideFiltersCategoryAndCollection ? setSelectedMobileFilter(filteredOptions[2] || {}) : removeCollectionOrCategoryFromPLP(getFilterType()) ? setSelectedMobileFilter(filteredOptions[0] || {}) : setSelectedMobileFilter(filteredOptions[1] || {});
    }, [
        hideFiltersCategoryAndCollection
    ]);
    (0,react.useEffect)(function() {
        if (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) {
            setSelectedFilter();
        }
    }, [
        toggleClick
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilter();
    }, [
        filteredOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? renderMobileFilterComponent() : renderDesktopFilterComponent()
    });
}
/* harmony default export */ var FilterComponent_FilterComponent = (FilterComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.styles.js

function FilterDrawer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    FilterDrawer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 56px;\n  border-bottom: 1px solid #eaeaea;\n  border-top: 1px solid #eaeaea;\n  @media screen and (max-width: ",
        "px) {\n    min-height: 56px;\n    z-index: 7;\n  }\n"
    ]);
    FilterDrawer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  margin-left: 16px;\n  align-items: center;\n"
    ]);
    FilterDrawer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  width: 124px;\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n"
    ]);
    FilterDrawer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FilterDrawer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  height: calc(100vh - ",
        "px);\n  padding-bottom: 40px;\n  ",
        ";\n"
    ]);
    FilterDrawer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var FilterDrawerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerContainer",
    componentId: "sc-9a833bb7-0"
})(FilterDrawer_styles_templateObject());
var FilterHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeading",
    componentId: "sc-9a833bb7-1"
})(FilterDrawer_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var FilterHeadingText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterHeadingText",
    componentId: "sc-9a833bb7-2"
})(FilterDrawer_styles_templateObject2());
var ClearAllCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClearAllCta",
    componentId: "sc-9a833bb7-3"
})(FilterDrawer_styles_templateObject3(), (0,getThemeColor/* getThemeColor */.p)());
var FilterDrawerDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FilterDrawerDesktop",
    componentId: "sc-9a833bb7-4"
})(FilterDrawer_styles_templateObject4(), function(props) {
    return props === null || props === void 0 ? void 0 : props.headerHeight;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.loader) ? "pointer-events : none" : " ";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js










function FilterDrawer(props) {
    var handleClearAll = /**
   * resets the filterOptions = [] and filtereditems = []
   * and filteredApplied counter goes to 0
   * reset payload api gets called again
   */ function handleClearAll() {
        var ref, ref1;
        dispatch((0,catalog/* filtersCounter */.Ds)(constants/* DEFAULT_FILTER_COUNT_VALUE */.Tv, true));
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId)) {
            router.reload(router === null || router === void 0 ? void 0 : router.asPath);
            return;
        }
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload));
    };
    var renderFilterDrawerHeading = function renderFilterDrawerHeading() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterHeading, {
            ref: filterHeadingRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterHeadingText, {
                    children: "Filters"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClearAllCta, {
                    onClick: handleClearAll,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pointer",
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: "Clear All"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function(e) {
                                e.stopPropagation();
                                handleShowFilterDrawer();
                            },
                            className: "ml12px flex align-center pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGrey/* CloseIconGrey */.U, {})
                        })
                    ]
                })
            ]
        });
    };
    var renderFilterDrawerDesktop = function renderFilterDrawerDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawerDesktop, {
            ref: filterDrawerRef,
            loader: filterOptionLoader,
            headerHeight: FilterDrawerTopMargin,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
                hideCollectionFilter: props.hideCollectionFilter,
                hideCategoryFilter: props.hideCategoryFilter,
                hideTags: props.hideTags
            })
        });
    };
    var renderFilterDrawerMobile = function renderFilterDrawerMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterComponent_FilterComponent, {
            hideCollectionFilter: props.hideCollectionFilter,
            hideCategoryFilter: props.hideCategoryFilter
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var handleShowFilterDrawer = props.handleShowFilterDrawer;
    var filterDrawerRef = (0,react.useRef)();
    var filterHeadingRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), filterHeadingHeight = ref[0], setFilterHeadingHeight = ref[1];
    var ref1;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref2, ref3;
        return {
            headerHeight: (ref1 = (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref2 = ref.headerRef) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) !== null && ref1 !== void 0 ? ref1 : 0,
            sortType: state.catalogReducer.sortType,
            storeData: state.storeReducer.store,
            filterOptionLoader: state.commonReducer.filterOptionLoader
        };
    }), headerHeight = ref2.headerHeight, sortType = ref2.sortType, storeData = ref2.storeData, filterOptionLoader = ref2.filterOptionLoader;
    (0,react.useEffect)(function() {
        if (filterHeadingRef.current) {
            var ref;
            setFilterHeadingHeight((ref = filterHeadingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isMobile) {
            var styleOverflowHidden = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            };
            var styleOverflowAuto = function() {
                document.getElementsByTagName("body")[0].style.overflowY = "auto";
            };
            if (filterDrawerRef.current) {
                var ref, ref1;
                (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("mouseover", styleOverflowHidden);
                (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("mouseout", styleOverflowAuto);
                return function() {
                    var ref, ref1;
                    (ref = filterDrawerRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("mouseover", styleOverflowHidden);
                    (ref1 = filterDrawerRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("mouseout", styleOverflowAuto);
                };
            }
        }
    }, []);
    var FilterDrawerTopMargin = headerHeight + filterHeadingHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterDrawerContainer, {
        children: [
            renderFilterDrawerHeading(),
            isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop()
        ]
    });
}
/* harmony default export */ var FilterDrawer_FilterDrawer = (FilterDrawer);


/***/ }),

/***/ 8710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FM": function() { return /* binding */ MB7_SORT_FILTER_TEMP_STORAGE_KEY; },
/* harmony export */   "Tr": function() { return /* binding */ getStoredMB7SortAndFilterConfig; },
/* harmony export */   "Wu": function() { return /* binding */ scrollIfItemPreviouslyClicked; },
/* harmony export */   "lr": function() { return /* binding */ setMB7SortAndFilterConfig; }
/* harmony export */ });
/* unused harmony export MB7_SORT_FILTER_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87243);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44779);




var MB7_SORT_FILTER_STORAGE_KEY = "mb7SortAndFilterConfig";
var MB7_SORT_FILTER_TEMP_STORAGE_KEY = "mb7SortAndFilterConfigTemp";
function scrollIfItemPreviouslyClicked() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__/* .scrollOnPageLoad */ .l)();
    if (scrollConfig.toScroll) {
        try {
            var y_scroll = scrollConfig.y_scroll;
            setTimeout(function() {
                sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
                window.scrollTo({
                    top: y_scroll
                });
            }, 300);
        } catch (err) {
            console.log("timeout time error:", err);
        }
    }
}
function getStoredMB7SortAndFilterConfig() {
    if (_utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY)) {
        return _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY);
    }
    return {
        filterAppliedCounter: 0,
        sortType: 0,
        collectionId: null,
        cid: null,
        isNextPage: true,
        pageNo: 1,
        filteredItems: [],
        filteredOptions: [],
        allowReset: true,
        filterAppliedCounterChanged: false,
        sortTypeChanged: false
    };
}
function setMB7SortAndFilterConfig(data) {
    var temp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentStoredData = getStoredMB7SortAndFilterConfig();
    var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, currentStoredData, data);
    if (temp) {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_TEMP_STORAGE_KEY, newData);
    } else {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_STORAGE_KEY, newData);
    }
}


/***/ }),

/***/ 68464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39996);



/***/ }),

/***/ 98331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97429);



var FlatListV2 = function(param) {
    var children = param.children, loadMoreData = param.loadMoreData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var hasLoaded = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var isVisible = (0,src_hooks_useOnScreen__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref, {
        threshold: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isVisible && !hasLoaded.current) {
            loadMoreData();
            hasLoaded.current = true;
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FlatListV2);


/***/ }),

/***/ 97429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useOnScreen = function(ref, options) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersecting = _$ref[0], setIntersecting = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var current = ref.current;
        if (!current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            setIntersecting(entry.isIntersecting);
        }, options);
        observer.observe(current);
        return function() {
            if (current) observer.unobserve(current);
            observer.disconnect();
        };
    }, [
        ref,
        options
    ]);
    return isIntersecting;
};
/* harmony default export */ __webpack_exports__["Z"] = (useOnScreen);


/***/ }),

/***/ 2876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);




/**
 *
 * @param {*} ref reference to the div element whose height is checked from top
 * @param {*} generalConditon a set of condition that can overwrite the logic if true
 * @param {*} offsetTopHeight when element height distance is less than this value setstate triggers
 * @param {*} offsetBottomHeight when element height distance is less than this value setstate triggers
 * @returns {boolean} is element height is under offsetTopHeight or not
 */ function useTriggerChangeTopHeightMobile(ref, generalConditon, offsetTopHeight, offsetBottomHeight) {
    var checkifScrolledOffset = function checkifScrolledOffset() {
        var _$ref, _$ref1;
        if (((_$ref1 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect()) === null || _$ref1 === void 0 ? void 0 : _$ref1.top) <= offsetTopHeight) {
            var _$ref2, _$ref3;
            if (((_$ref3 = (_$ref2 = ref.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBoundingClientRect()) === null || _$ref3 === void 0 ? void 0 : _$ref3.bottom) <= offsetBottomHeight) {
                setIsElementUnderOffset(false);
            } else setIsElementUnderOffset(true);
        } else setIsElementUnderOffset(false);
    };
    if (generalConditon) generalConditon;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isElementUnderOffset = ref1[0], setIsElementUnderOffset = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAX_MOBILE_WIDTH */ .Cf) window.addEventListener("scroll", checkifScrolledOffset);
        checkifScrolledOffset();
        return function() {
            window.removeEventListener("scroll", checkifScrolledOffset);
        };
    }, []);
    return isElementUnderOffset;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerChangeTopHeightMobile);


/***/ }),

/***/ 42249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96031);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68037);




function useTriggerInitialFilterOptions() {
    var additionalCondition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var callInitialGetFilteredItemsOptions = function callInitialGetFilteredItemsOptions() {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: []
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFilteredItemsOptions */ .OI)(payload));
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var storeData = (0,_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return {
            sortType: state.catalogReducer.sortType,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter
        };
    }), sortType = ref.sortType, filterAppliedCounter = ref.filterAppliedCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!filterAppliedCounter && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && additionalCondition) {
            callInitialGetFilteredItemsOptions();
        }
    }, [
        filterAppliedCounter,
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        additionalCondition
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTriggerInitialFilterOptions);


/***/ }),

/***/ 36051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getFilteredOptionsProducts; }
/* harmony export */ });
/* harmony import */ var _components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8710);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80344);



var getFilteredOptionsProducts = function(filterOptions) {
    var pageNo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, extraField = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isMiddleBody7: false
    };
    var ref;
    var storeId = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var sorting_type = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().catalogReducer) === null || ref === void 0 ? void 0 : ref.sortType;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .Z.dispatch;
    if (extraField === null || extraField === void 0 ? void 0 : extraField.isMiddleBody7) {
        var ref1;
        var isNextPage = (ref1 = (0,_components_DesignSystem_MiddleBody_MiddleBody7_utils__WEBPACK_IMPORTED_MODULE_0__/* .getStoredMB7SortAndFilterConfig */ .Tr)()) === null || ref1 === void 0 ? void 0 : ref1.isNextPage;
        if (!isNextPage) {
            return {
                status: false,
                is_next_page: false
            };
        }
    }
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .getFilteredItemsOptions */ .OI)({
            store_id: storeId,
            page_no: pageNo,
            sorting_type: sorting_type,
            filters: filterOptions
        }, function(status, is_next_page) {
            return status ? resolve({
                status: status,
                is_next_page: is_next_page
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 87243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ })

}]);